"use strict";
exports.__esModule = true;
var angular = require("angular");
function generateTagsMap(tags) {
    var categoryMap = {};
    tags.forEach(function (tag) {
        var tagArr = tag.split(':');
        if (tagArr.length == 2) {
            var categoryName = tagArr[0], selectedEntry = tagArr[1];
            categoryMap[categoryName] = selectedEntry;
        }
    });
    return categoryMap;
}
exports.generateTagsMap = generateTagsMap;
function generateTagsData(node, tags, categoriesData, nonPropagateCateSet) {
    if (tags === void 0) { tags = []; }
    if (categoriesData === void 0) { categoriesData = []; }
    if (nonPropagateCateSet === void 0) { nonPropagateCateSet = new Set(); }
    var leafCategoryMap = generateLeafCategoryMap(tags, categoriesData);
    var tagsData = [formatTagsData(node._id, leafCategoryMap)]; //[[]]
    var currentNode = node;
    var currentCategoryMap = leafCategoryMap;
    while (currentNode) {
        if (!currentNode.parent) {
            break;
        }
        var parentNode = currentNode.parent;
        var parentCategoryMap = generateParentCategoryMap(parentNode, currentCategoryMap, currentNode._id, nonPropagateCateSet);
        tagsData.push(formatTagsData(parentNode._id, parentCategoryMap));
        // pathTagsData(currentNode.parent, categoryMap, currentNode._id);
        currentNode = parentNode;
        currentCategoryMap = parentCategoryMap;
    }
    return tagsData;
}
exports.generateTagsData = generateTagsData;
function generateLeafCategoryMap(tags, categoriesData) {
    var categoryMap = {};
    tags.forEach(function (tag) {
        var tagArr = tag.split(':');
        if (tagArr.length == 2) {
            var categoryName = tagArr[0], selectedEntry = tagArr[1];
            if (!(categoryName in categoryMap)) {
                categoryMap[categoryName] = new Set();
            }
            categoryMap[categoryName].add(selectedEntry);
        }
    });
    categoriesData.forEach(function (category) {
        if (category.selectedEntry) {
            categoryMap[category.CategoryName] = new Set([category.selectedEntry]);
        }
        else {
            delete categoryMap[category.CategoryName];
        }
    });
    return categoryMap;
}
function generateParentCategoryMap(node, childCategoryMap, childId, nonPropagateCateSet) {
    var categoryMap = {};
    for (var cateName in childCategoryMap) {
        if (nonPropagateCateSet.has(cateName)) {
            continue;
        }
        categoryMap[cateName] = childCategoryMap[cateName];
    }
    node.children.forEach(function (child) {
        if (child._id === childId) {
            return;
        }
        child.tags.forEach(function (tag) {
            var tagArr = tag.split(':');
            if (tagArr.length == 2 && !nonPropagateCateSet.has(tagArr[0])) {
                var categoryName = tagArr[0], selectedEntry = tagArr[1];
                if (!(categoryName in categoryMap)) {
                    categoryMap[categoryName] = new Set();
                }
                categoryMap[categoryName].add(selectedEntry);
            }
        });
    });
    return categoryMap;
}
function formatTagsData(nodeId, categoryMap) {
    var tags = ['all'];
    Object.entries(categoryMap).forEach(function (_a) {
        var categoryName = _a[0], selectedEntries = _a[1];
        if (selectedEntries) {
            selectedEntries.forEach(function (selectedEntry) {
                tags.push(categoryName + ':' + selectedEntry);
            });
        }
    });
    return [nodeId, tags.toString()];
}
/**
 * Generate data of category history
 * {
 *     lastVal: String entryName,
 *     msg: String ...,
 *     SavedOn:String Date,
 *     SavedBy:String username
 * }
 * @param categoriesData: Array<CategoryItem>
 * @param origCategoriesData: Array<CategoryItem>
 * @param user: String
 */
function generateLogData(categoriesData, origCategoriesData, user) {
    var categoryLogData = {};
    var savedOn = formatTimeStamp();
    categoriesData.forEach(function (cateItem, index) {
        var origCateItem = origCategoriesData[index];
        if (cateItem.selectedEntry === origCateItem.selectedEntry &&
            angular.equals(cateItem.comment, origCateItem.comment)) {
            return;
        }
        var commentMsg = encodeURIComponent(cateItem.comment.val);
        categoryLogData[cateItem.CategoryName] = {
            lastVal: origCateItem.selectedEntry || null,
            msg: commentMsg,
            SavedBy: user,
            SavedOn: encodeURIComponent(savedOn)
        };
    });
    return categoryLogData;
}
exports.generateLogData = generateLogData;
function formatTimeStamp() {
    var date = new Date();
    var dateArr = date.toDateString().split(" ");
    var timeStr = date.toTimeString().split(" ")[0];
    dateArr.splice(3, 0, timeStr);
    return dateArr.join(" ");
}
/**
 * format data for history modal display
 * @param historyModalData: any[]
 * @param currentVal: String
 */
function formatHistoryModalData(historyModalData, currentVal) {
    var commentVals = historyModalData.map(function (comment) { return comment.lastVal; });
    commentVals.unshift(currentVal);
    historyModalData.forEach(function (comment, i) {
        comment.val = commentVals[i] || "(Not Selected)"; // shift vals according to next lastVal
        comment.SavedOn = decodeURIComponent(comment.SavedOn);
        var decodedMsg = decode(comment.msg);
        comment.decodedMsg = decodedMsg;
        var parsedHTML = $.parseHTML(decodedMsg);
        comment.msgStr = (parsedHTML && parsedHTML.length > 0 && typeof getTextContent(parsedHTML[0]) !== 'undefined') ?
            trimComment(parseHTMLtoString(decodedMsg)) :
            trimComment(decodedMsg);
    });
    historyModalData.push({ val: (commentVals.pop() || "(Not Selected)") });
    return historyModalData;
}
exports.formatHistoryModalData = formatHistoryModalData;
function decode(string) {
    try {
        return decodeURIComponent(string);
    }
    catch (e) {
        return string;
    }
}
function trimComment(comment) {
    if (comment && comment.length > 50) {
        comment = comment.substring(0, 49) + "...";
    }
    return comment;
}
exports.trimComment = trimComment;
function getTextContent(element) {
    if (!element) {
        return undefined;
    }
    if (typeof element['outerText'] !== 'undefined') {
        return element['outerText'];
    }
    return element['textContent'];
}
function parseHTMLtoString(comment) {
    var str = "";
    for (var i = 0; i < $.parseHTML(comment).length; i++) {
        str += getTextContent($.parseHTML(comment)[i]) + " ";
    }
    return str.trim();
}
//# sourceMappingURL=project-category-assignment.logic.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/project-category-assignment/project-category-assignment.logic.js